// SPDX-License-Identifier: LicenseRef-Proprietary
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './components/auth/Auth.css';
import VaccineClientApp from './vaccine-client/App';
import { AuthGuard } from './components/auth/AuthGuard';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <AuthGuard>
      <VaccineClientApp />
    </AuthGuard>
  </React.StrictMode>
);

